import React, { FunctionComponent, memo, ReactElement } from 'react'
import Text from '../Text'
import Fontello, { getFontFamily } from '../../Fontello'
import { BaseFontProps } from '../../styles/types'

export type FontelloIconProps = BaseFontProps & {
    name: string
    children?: never
    textAlign?: 'center' | 'right' | 'left'
}

const FontelloIcon: FunctionComponent<FontelloIconProps> = ({
    name,
    ...rest
}): ReactElement | null => {
    const glyph = Fontello(name && name.toLowerCase())

    if (glyph) {
        return (
            <Text
                fontFamily={getFontFamily()}
                selectable={false}
                allowFontScaling={false}
                {...rest}
            >
                {String.fromCharCode(glyph)}
            </Text>
        )
    }

    return null
}

export default memo(FontelloIcon)
